import React, { useEffect } from 'react';
import {
  Switch,
  Redirect,
  Route,
} from 'react-router';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { PagesMainBar } from '../components';
import pagesRoutes from '../routes/pages';
import { storePromoCodeFromURL } from '../utility/promotionCode';
import { selectCurrentUser } from '../store/modules/users/selectors';
import PromoNote from '../views/pages/Pricing/components/PromoNote/PromoNote';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    backgroundColor: '#F6F6F6',
    minHeight: '100vh',
    flexDirection: 'column',
  },
  container: {
    height: '100%',
  },
}), { name: 'PagesLayout' });

const PagesLayout = () => {
  const classes = useStyles();
  const { data: user } = useSelector(selectCurrentUser);

  useEffect(() => {
    if (!user) {
      storePromoCodeFromURL();
    }
  }, [user]);

  return (
    <div className={classes.root}>
      <PagesMainBar />
      <PromoNote />
      <div className={classes.container}>
        <Switch>
          {pagesRoutes.map((route) => {
            if ('to' in route) {
              return (
                <Redirect
                  key={route.from}
                  {...route}
                />
              );
            }
            return (
              <Route
                key={Array.isArray(route.path) ? route.path.join(';') : route.path}
                {...route}
              />
            );
          })}
        </Switch>
      </div>
    </div>
  );
};

export default PagesLayout;
